import './interceptors';
/*
 * 扫描该目录下所有index文件
 */
function getModules () {
    const files = require.context('./modules', true, /api\.js$/);
    return files.keys()
        .reduce((modules, key) => {
            const module = files(key);
            return Object.assign(modules, module.default || module);
        }, {});
}

export default getModules();
